import { useTranslation } from 'react-i18next';
import { Button } from '../../ui/Button/Button';
import { PrimaryButton } from '../../ui/PrimaryButton/PrimaryButton';
import styles from './FeedbackAndReceipt.module.css';

interface SecondaryActionsProps {
    isFeedbackActive: boolean;
    isReceiptActive: boolean;
    onFeedbackClick: () => void;
    onReceiptClick: () => void;
}

/**
 * Same two actions and the same button styles as the default layout, only
 * compact, so the amount field and the payment button keep the visual accent
 * (SWRN-1800). Stacked at one height, like the payment column above (SWRN-2111).
 */
const SecondaryActions = ({
    isFeedbackActive,
    isReceiptActive,
    onFeedbackClick,
    onReceiptClick,
}: SecondaryActionsProps): React.JSX.Element => {
    const { t } = useTranslation();

    return (
        <div className={styles.secondaryActions}>
            {isFeedbackActive && (
                <PrimaryButton type="button" className={styles.compactButton} onClick={onFeedbackClick}>
                    {t('Feedback')}
                </PrimaryButton>
            )}
            {isReceiptActive && (
                <Button type="button" className={styles.compactButton} onClick={onReceiptClick}>
                    {t('Fiscal receipt')}
                </Button>
            )}
        </div>
    );
};

export { SecondaryActions };
